<template>
  <div>
    <b-row class="mb-1">
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Volt</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="22"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/volt.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b> {{ volt }} </b>
            </div>
          </foreignObject>
        </svg>

      </b-col>
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Amp</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="22"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/amp.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b> {{ amp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} </b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Watt</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/watt.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b>{{ watt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</b>
            </div>
          </foreignObject>
        </svg>

      </b-col>
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Pf</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="15"
            y="12"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="35"
              src="@/assets/images/icons/semcontrol1/pf.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b>{{ pf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>kWh</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="15"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/kwh.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b>{{ kwh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</b>
            </div>
          </foreignObject>
        </svg>

      </b-col>
      <b-col
        lg="6"
        md="12"
        sm="12"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 361 143"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6474 142L1 126.761V9.27279H321.715L334.644 1.40747H360.387V9.27279V126.761L344.739 142H16.6474Z"
            stroke="#00B058"
          />
          <path
            d="M327.578 0.915894H331.616L320.511 7.79805H316.473L327.578 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M320.511 0.915894H324.549L313.444 7.79805H309.406L320.511 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M313.444 0.915894H317.482L306.377 7.79805H302.339L313.444 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M306.378 0.915894H310.416L299.311 7.79805H295.273L306.378 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M299.311 0.915894H303.349L292.244 7.79805H288.206L299.311 0.915894Z"
            fill="#00B058"
          />
          <path
            d="M292.244 0.915894H296.282L285.178 7.79805H281.14L292.244 0.915894Z"
            fill="#00B058"
          />
          <foreignObject
            x="60"
            y="17"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>Hz</strong>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="12"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <b-img
              height="30"
              src="@/assets/images/icons/semcontrol1/hz.svg"
            />
          </foreignObject>
          <foreignObject
            x="190"
            y="65"
            width="300"
            height="150"
            color="#ffffff"
            font-size="40"
            style="text-align: left;"
          >
            <div>
              <b>{{ hz.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</b>
            </div>
          </foreignObject>
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
  },
  data() {
    return {
      items: [],
      voltPhase1: [],
      volt: '',
      amp: '',
      watt: '',
      pf: '',
      kwh: '',
      hz: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getMarkerSem()
    this.interval = setInterval(() => {
      this.getMarkerSem()
    }, 10000)
  },
  mounted() {
  },
  methods: {
    getMarkerSem() {
      axios
        .post('/markerSEM1Phase', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
          this.volt = this.items[0].volt
          this.amp = this.items[0].amp
          this.watt = this.items[0].watt
          this.pf = this.items[0].pf
          this.kwh = this.items[0].kwh
          this.hz = this.items[0].hz
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

  <style lang="scss">
    .text1 {
      position: absolute;
      font-family: Arial;
      top: 20px;
      right: 20px;
      color: white;
    }
    </style>
